(() => {
  const articleImages = document.querySelectorAll('.wp-block-image a');
  const modal = document.querySelector('article-modal[id^="ArticleModal-"]');

  if (!articleImages || !modal) return;

  document.body.appendChild(modal);

  const dialog = modal.querySelector('.article-media-modal__dialog');
  const modalImage = modal.querySelector('[data-article-modal-image]');
  const closeButton = modal.querySelector('[data-article-modal-close]');

  if (!dialog || !modalImage || !closeButton) return;

  let previouslyFocusedElement = null;

  const getImageUrl = (image) => {
    const imageLink = image.closest('.wp-block-image')?.querySelector('a');

    if (imageLink?.href) {
      return imageLink.href;
    }

    return image.currentSrc || image.src;
  };

  const openModal = (image) => {
    const imageUrl = getImageUrl(image);

    if (!imageUrl) return;

    previouslyFocusedElement = document.activeElement;

    modalImage.src = imageUrl;
    modalImage.alt = image.alt || '';

    modal.classList.add('active');
    modal.setAttribute('open', '');
    modal.setAttribute('aria-hidden', 'false');

    document.body.classList.add('overflow-hidden');

    dialog.focus();
  };

  const closeModal = () => {
    modal.classList.remove('active');
    modal.removeAttribute('open');
    modal.setAttribute('aria-hidden', 'true');

    document.body.classList.remove('overflow-hidden');

    modalImage.src = '';
    modalImage.alt = '';

    previouslyFocusedElement?.focus();
  };

  articleImages.forEach((articleImage) => {
    articleImage.addEventListener('click', (event) => {
      event.preventDefault();

      const image = event.currentTarget.querySelector('img');

      if (!image) return;

      openModal(image);
    });
  });

  closeButton.addEventListener('click', closeModal);

  modal.addEventListener('click', () => {
    closeModal();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && modal.hasAttribute('open')) {
      closeModal();
    }
  });
})();
